module.exports = __webpack_public_path__ + "img/canceled.44d92caa.svg";